module.exports = __webpack_public_path__ + "img/home-5-mobileearth.5a96cfde.png";